import { useEffect } from "react";
import { useLocation } from "react-router";
import { useAppNavigation } from "src/contexts/AppNavigationContext";

// The navigation provider is above RouterProvider; route observation belongs here.
export default function CloseOnNavigation() {
    const location = useLocation();
    const { closeMobileDrawer } = useAppNavigation();
    useEffect(() => { closeMobileDrawer(); }, [location, closeMobileDrawer]);
    return null;
}
